import InnerHref from '../../../util/InnerHref';
import {Modal} from 'antd';
import isFunction from 'lodash/isFunction';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;


class CommentItem extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    const {approvalAtatus, discussantInfo = {}, remark, showDate, commentuserInfo, id,canReply} = this.props;
    const {isAnonymous, isDel} = this.props;
    const {op_isComCanDelete, op_isComCanReply} = this.props;
    return (
      <div className="wea-cowork-comment-item">
        <div>
          <div>
            <div className="cowork-reply-content">
              <div>
                  <span className="cowork-reply-user">
                    {isAnonymous == 1 ? <span >{discussantInfo.lastname}</span>:
                      <a  href={`javaScript:openhrm(${discussantInfo.id});`} onClick={window.pointerXY}>{discussantInfo.lastname}</a>}
                    {commentuserInfo && commentuserInfo.id && (
                      <span>
                        <span className="ml5">{getLabel(128123, '回复')}</span>
                        {
                          commentuserInfo.id == -1 ?<span className="ml5">{commentuserInfo.lastname}</span>:
                          <a className="ml5" href={`javaScript:openhrm(${commentuserInfo.id});`} onClick={window.pointerXY} >{commentuserInfo.lastname}</a>
                      }
                      </span>
                    )}
                    <span className="reply-time">{showDate}</span>
                  </span>
                <span className="fr">
                  {op_isComCanDelete == 1 && <span className="cowork-top-icon icon-coms-delete" onClick={this.delete} title={getLabel(91,'删除')}/>}
                  {op_isComCanReply == 1 && canReply && <span className="cowork-top-icon icon-coms-New-SMS" onClick={this.props.reply.bind(this, id)} title={getLabel(128123, '回复')}/>}
                </span>
              </div>
              <div className="cowork-reply-remark wea-f12">
                <div
                  className="wea-cl-content"
                  dangerouslySetInnerHTML={{__html: `<div class="wea-ckeditor-content">${remark}</div>`}}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  delete = () => {
    let that = this;
    Modal.confirm({
      content: getLabel(4903, '确认要删除该评论','note'),
      onOk() {
        isFunction(that.props.operate) && that.props.operate({
          id: that.props.id,
          coworkId: that.props.coworkid,
          operationType: 'delComment',
          discussId: that.props.topdiscussid
        });
      }
    });
  }
}

export default CommentItem;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cowork/components/cowork/item/CommentItem.js